<template>
  <div>
    <template v-if="state.configurations.length==1">
      <!-- Si une seule config proposée -->
      <p class="h3 mb-2 pt-2 pb-4">Voici la puissance adaptée à votre situation</p>
      <div class="row two-parts">
        <div class="col-lg-7">
          <ul class="list-unstyled d-flex h-100 align-items-center">
            <li v-for="radiator in the_singles(state.configurations[0].radiatorsFetched) " class="position-relative">
                <img class="w-100" :src="require('@/assets/img/radiateurs/'+the_image(radiator[1]))">
                <span class="radiator-count single-rad bg-primary"><small><strong>x{{ radiator[0] }}</strong></small></span>
            </li>
          </ul>
        </div>
        <div class="col-lg-5 mt-4  mt-md-0 px-md-0 text-center d-flex flex-column justify-content-center align-items-center single-config">
          <p>La configuration optimale est de </p>
          <p class="h1 mb-3 px-4" v-html="the_config(state.configurations[0].radiatorsFetched)"></p>
          <p class="text-secondary">Soit un total de {{ the_total(state.configurations[0].radiatorsFetched) }} W</p>
          <div class="btn mt-4 btn-md btn-primary rounded-pill" @click="selectConfig(state.configurations[0])">
            Étape suivante
          </div>
        </div>
      </div>
    </template>

    <!-- Si plusieurs configs -->
    <div v-else>
      <p class="h3 mb-2 pt-2 pb-4">Sélectionnez la configuration qui vous convient le mieux </p>
      <div class="form-check check-tile mb-3" v-for="(config,i) in state.configurations">
        <input class="form-check-input d-none" type="radio" name="step-1" id="exampleRadios2" value="option2">
        <label class="form-check-label" for="exampleRadios2" @click="selectConfig(config)">

          <div class="d-flex align-items-center">
            
            <div class="d-flex align-items-center ml-n3 py-2 mr-3">
              <div class="position-relative"  v-for="radiator in the_singles(config.radiatorsFetched)">
                  <img :src="require('@/assets/img/radiateurs/'+the_image(radiator[1]))" v-b-tooltip.hover :title="radiator[1].power+'W ('+radiator[1].width+'cm x '+radiator[1].height+'cm x 8cm)'">
                  <span class="radiator-count bg-primary"><small><strong>x{{ radiator[0] }}</strong></small></span>
              </div>
            </div>

            <div>
               <p class="mb-0 lead">Configuration {{ i + 1 }} <small class="text-secondary">{{ the_total(config.radiatorsFetched) }}W</small></p>
               <span class="text-secondary" v-html="the_config(config.radiatorsFetched)" ></span>
              
            </div>

          </div>

          <i class="fal fa-arrow-right fa-2x text-primary"></i>
        </label>
      </div>

    </div>

  </div>
</template>

<script>
import pnl from "@/mixins/pnl";

export default {
  name: "PowerShow",
  mixins: [pnl],
  async mounted() {
    this.setData('configurations', await this.calcPower());
    this.setDataRad('finition','Brillant')
    this.setDataRad('orientation','horizontal')
    this.setDataRad('thermostat',null)
    this.setDataRad('color',{
      name:'Blanc reflet vert',
      class:'degrade-blanc-reflet',
      checkColor:'text-black',
    })
    this.setDataRad('towelDryers','2')
  },
  methods: {
    countOccurrences(arr, val) {
      return arr.reduce((a, v) => (v === val ? a + 1 : a), 0);
    },
    the_config(config) {
      let name = '';
      let singles = new Set(config)
      singles.forEach(rad => {
        name += this.countOccurrences(config, rad) + ' x ' + rad.power + 'W <small>('+rad.width+'cm x '+rad.height+'cm x 8cm)</small> <br/>';
      })
      name = name.slice(-name.length, name.length - 3)
      return name;
    },
    the_singles(config) {
      let img = [];
      let singles = new Set(config)
      singles.forEach(rad => {
        img.push([this.countOccurrences(config, rad),rad]);
      })
      return img;
    },
    selectConfig(config) {
      this.setData('selected_config', config);
      if (config.orientable)this.$router.push({name: 'OrientationSelection'})
      else this.$router.push({name: 'ColorSelection'})
    },
    the_total(config) {
      let total = 0;
      let singles = new Set(config)
      singles.forEach(rad => {
        total += this.countOccurrences(config, rad) * parseInt(rad.power)
      })
      return total;
    }
  }
}
</script>

<style scoped>

</style>